<template>
    <div ref="remodal" class="remodal car-alert-modal" tabindex="-1" :data-remodal-id="this.remodalId" :id="remodalId" data-remodal-options="hashTracking: false, closeOnOutsideClick: false">
        <a data-remodal-action="close" class="remodal-close"></a>

        <picture>
            <source media="(min-width: 992px)" srcset="/images/used/car-alert/header-image.webp, /images/used/car-alert/header-image@2x.webp 2x" type="image/webp">
            <source media="(min-width: 992px)" srcset="/images/used/car-alert/header-image.jpg, /images/used/car-alert/header-image@2x.jpg 2x">
            <source srcset="/images/used/car-alert/header-image-mobile.webp" type="image/webp">
            <img srcset="/images/used/car-alert/header-image-mobile.jpg" alt="" class="img-responsive car-alert-modal__img">
        </picture>

        <form @submit.prevent="submit" ref="form" class="material-form car-alert-modal__form" data-form-name="Used Vehicles - Stock Alert" v-if="complete === false">
            <h2 class="car-alert-modal__h2">FIND YOUR PERFECT CAR</h2>
            <p class="car-alert-modal__subtitle">With new cars being added to the website every day. Create an email alert to be notified when your perfect car arrives in stock.</p>

            <div class="form-inline">
                <div class="form-group">
                    <input id="search-name" v-model="searchName" :class="{ active: searchName !== '' }" class="form-control" data-validate="input" data-validate-message="Please enter a name for the stock alert" type="text" name="name">
                    <label for="search-name">Stock Alert Name*</label>
                    <span class="input-border"></span>
                </div>
            </div>

            <div class="form-inline">
                <div class="form-group">
                    <select class="form-control active" id="alert-frequency" v-model="alertFrequency">
                        <option value="instant">Instantly</option>
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                    </select>
                    <label for="alert-frequency">How often would you like to receive alerts? *</label>
                    <span class="input-border"></span>
                </div>
            </div>

            <div class="form-inline">
                <div class="form-group">
                    <input id="customer-name" v-model="customerName" :class="{ active: customerName !== '' }" class="form-control" data-validate="input" data-validate-message="Please enter your name" type="text" name="name">
                    <label for="customer-name">Enter your name *</label>
                    <span class="input-border"></span>
                </div>
            </div>

            <div class="form-inline">
                <div class="form-group">
                    <input id="customer-email" v-model="customerEmail" :class="{ active: customerEmail !== '' }" class="form-control" data-validate="email" data-validate-message="Please enter your email address" type="email" name="email">
                    <label for="customer-email">Enter your email *</label>
                    <span class="input-border"></span>
                </div>
            </div>

            <button @click.prevent="submit" type="button" class="btn btn-primary btn-md btn-full-width-xs car-alert-modal__btn">Submit</button>
        </form>
        <template v-else>
            <h1 class="text-center">THANK YOU FOR CREATING A STOCK ALERT</h1>
            <p class="car-alert-modal__thank-you">
                Your personalised stock alert has now been set up and you will receive an email <template v-if="alertFrequency == 'instant'">as soon as new stock arrives</template><template v-else-if="alertFrequency == 'daily'">summary of new stock each day</template><template v-else-if="alertFrequency == 'weekly'">summary of new stock each week</template>
            </p>
            <div class="car-alert-modal__btn-row text-center">
                <a href="/car-valuation" class="btn btn-valuation btn-md btn-full-width-xs car-alert-modal__btn-valuation">Value my car</a>
                <button type="button" class="btn btn-primary car-alert-modal__btn-close" @click="open = false">Return to search</button>
            </div>
        </template>
    </div>
</template>

<script>
import EventObject from '../../modules/tracking/EventObject';
import getDefaultCarAlertName from '../api/car-alert/GetDefaultCarAlertName';

export default {
    components: {
    },
    data() {
        return {
            validator: false,

            searchName: '',
            customerName: '',
            customerEmail: '',
            alertFrequency: 'instant',
        };
    },
    computed: {
        open: {
            get() {
                return this.$store.state.CarAlert.showModal;
            },
            set(val) {
                this.$store.commit('CarAlert/setShowModal', val);
            }
        },
        complete: {
            get() {
                return this.$store.state.CarAlert.complete;
            },
            set(val) {
                this.$store.commit('CarAlert/setComplete', val);
            }
        },
        remodalId() {
            return 'used-car-alert-' + this._uid;
        },
    },
    watch: {
        open: function(newValue) {
            if (!this.$refs.remodal) {
                console.error('no remodal instance');
            }

            const instance = $(this.$refs.remodal).remodal({
                hashTracking: false,
                closeOnOutsideClick: false
            });

            // Only open it if it's not already open
            const remodalState = instance.getState();
            if (newValue == true) {
                // When opening, set the initial search name
                this.searchName = getDefaultCarAlertName();

                if (remodalState == 'closed' || remodalState == 'closing') {
                    instance.open();
                }
                return;
            }

            if (remodalState == 'open' || remodalState == 'opened' || remodalState == 'opening') {
                instance.close();
            }
            return;
        },
    },
    methods: {
        async submit() {
            if (!await this.validator.isValid()) {
                return;
            }

            this.validator.preventInput();

            const response = await axios.post('/api/used-vehicles/car-alert', {
                search_name: this.searchName,
                name: this.customerName,
                email: this.customerEmail,
                alert_frequency: this.alertFrequency,
                lat: this.$store.state.Dealers.lat,
                lng: this.$store.state.Dealers.lng,
                manufacturer: this.$store.state.UsedSearchOptions.userOptions.manufacturer,
                model: this.$store.state.UsedSearchOptions.userOptions.model,
                distance: this.$store.state.UsedSearchOptions.userOptions.distance,
                minPrice: this.$store.state.UsedSearchOptions.userOptions.minPrice,
                maxPrice: this.$store.state.UsedSearchOptions.userOptions.maxPrice,
                mileage: this.$store.state.UsedSearchOptions.userOptions.mileage,
                fuelType: this.$store.state.UsedSearchOptions.userOptions.fuelType,
                transmission: this.$store.state.UsedSearchOptions.userOptions.transmission,
                colour: this.$store.state.UsedSearchOptions.userOptions.colour,
            })
            .catch(e => {
                this.validator.errorResponse(e);
            })

            this.validator.allowInput();

            if (!response) {
                return false;
            }

            new EventObject('Stock Alert', 'Popup form', 'Submitted').dispatch();

            this.$store.commit('CarAlert/setComplete', true);
        }
    },
    mounted() {
        $(document).on('closing', '#'+this.remodalId, (e) => {
            this.$store.commit('CarAlert/setShowModal', false);
        });
        $(document).on('closed', '#'+this.remodalId, (e) => {
            this.$store.commit('CarAlert/setShowModal', false);
        });
        $(document).on('opening', '#'+this.remodalId, (e) => {
            this.$store.commit('CarAlert/setShowModal', true);
        });
        $(document).on('open', '#'+this.remodalId, (e) => {
            this.$store.commit('CarAlert/setShowModal', true);
        });

        this.validator = new ContactFormValidator({
            element: $(this.$refs.form),
            vueForm: true
        });
    }
}
</script>
